import { resolveTypeAlias } from "./aliases";
import type { FilterToken } from "./types";

const SUPPORTED_KEYS = ["type", "id"];

const ID_PATTERN = /^\d+$/;

/**
 * Parses a single typed word (e.g. `type:contact`, `id:283`) into a filter
 * token, or returns null when it isn't a recognized `key:value` DSL
 * fragment — in which case it's left as plain search text.
 */
export function parseToken(word: string): FilterToken | null {
  const trimmed = word.trim();
  const separatorIndex = trimmed.indexOf(":");

  if (separatorIndex <= 0 || separatorIndex === trimmed.length - 1) {
    return null;
  }

  const key = trimmed.slice(0, separatorIndex).toLowerCase();
  const rawValue = trimmed.slice(separatorIndex + 1);

  if (!SUPPORTED_KEYS.includes(key)) {
    return null;
  }

  if ("id" === key) {
    return ID_PATTERN.test(rawValue) ? { key, value: rawValue } : null;
  }

  const value = resolveTypeAlias(rawValue);

  return value ? { key, value } : null;
}
